import ModalBasic from "Components/Modal/Modal";
import { ReactComponent as CreditCardIcon } from "Assets/CreditCard.svg";
import { ReactComponent as CalendarIcon } from "Assets/Calendar.svg";
import { ReactComponent as DollarIcon } from "Assets/Dollar.svg";
import Decimal from "decimal.js";
import "Colors.css";
import Table from "Components/Common/Table/Table";

const HEADING_CSS =
  "flex flex-col gap-2 text-md font-medium light_grayish_navy";
const SUB_HEADING_CSS = "flex gap-2 items-center text-md font-normal sapphire";
const REFUND_TABLE_HEADINGS = [
  "Refunded Amount",
  "Remaining Balance",
  "Date and Time",
];
const CART_TABLE_HEADINGS = ["Type", "Item", "Price"];

const ADJUSTMENT_TYPES = {
  DISCOUNT: "Discount",
  SPONSOR: "Sponsor",
};

const PRODUCT_TYPES = {
  PRIMARY: "Primary",
  ADD_ON: "Add-on",
};

const formatCartItemType = (item) => {
  if (item.adjustmentType) {
    return ADJUSTMENT_TYPES[item.adjustmentType] || item.adjustmentType;
  }
  if (item.product) {
    return PRODUCT_TYPES[item.product] || item.product;
  }
  return "-";
};

const CART_SORT_ORDER = { PRIMARY: 0, ADD_ON: 1 };

const sortCartItems = (cart) => {
  return [...cart].sort((a, b) => {
    const orderA = a.product ? (CART_SORT_ORDER[a.product] ?? 2) : 2;
    const orderB = b.product ? (CART_SORT_ORDER[b.product] ?? 2) : 2;
    return orderA - orderB;
  });
};

const formatCartItemPrice = (item) => {
  if (item.adjustmentType === "SPONSOR") {
    if (item.adjustmentValue == null) return "-";
    return new Decimal(Number(item.adjustmentValue)).toFixed(2);
  }
  if (item.price == null) return "-";
  return new Decimal(item.price).toFixed(2);
};

export const PaymentDetailsModal = ({
  isModalOpen,
  onCancel,
  paymentDetails,
}) => {
  return (
    <ModalBasic
      icon={<CreditCardIcon />}
      heading="Payment Details"
      open={isModalOpen}
      setOpen={() => {
        onCancel();
      }}
      minWidth="600px"
    >
      <div className="flex flex-col gap-6 ">
        <span className={HEADING_CSS}>
          <span className={SUB_HEADING_CSS}>
            <CalendarIcon className="w-6 h-6 light_grayish_navy pointer-events-none" />{" "}
            {paymentDetails.date}
          </span>
        </span>
        {paymentDetails?.cart?.length > 0 && (
          <span className={HEADING_CSS}>
            Cart Items
            <Table
              heading={<CartTableHeading />}
              body={<CartTableBody data={sortCartItems(paymentDetails.cart)} />}
            />
          </span>
        )}
        <span className={HEADING_CSS}>
          Total Amount{" "}
          <span className={SUB_HEADING_CSS}>
            {" "}
            <DollarIcon className="w-6 h-6 light_grayish_navy pointer-events-none" />
            {paymentDetails.amount}
          </span>
        </span>
        <div className="overflow-y-auto overflow-x-hidden">
          {paymentDetails?.refunds.length > 0 && (
            <Table
              heading={<RefundTableHeading />}
              body={
                paymentDetails?.refunds?.length > 0 ? (
                  <RefundTableBody data={paymentDetails?.refunds} />
                ) : (
                  "No Data Found"
                )
              }
            />
          )}
        </div>
      </div>
    </ModalBasic>
  );
};

const CartTableHeading = () => {
  return CART_TABLE_HEADINGS.map((head, index) => (
    <th
      key={index}
      scope="col"
      className="bali_hai px-6 py-3 text-left text-sm font-medium"
    >
      {head}
    </th>
  ));
};

const CartTableBody = ({ data }) => {
  const TABLE_ROW =
    "px-6 py-4 whitespace-nowrap text-sm font-normal sapphire";
  const PRIMARY_ROW =
    "px-6 py-4 whitespace-nowrap text-sm font-bold text-blue-chill";

  return (
    <>
      {data?.map((item, index) => {
        const rowClass = item.product === "PRIMARY" ? PRIMARY_ROW : TABLE_ROW;
        return (
        <tr key={index}>
          <td className={rowClass}>{formatCartItemType(item)}</td>
          <td className={rowClass}>{item.name || "-"}</td>
          <td className={rowClass}>
            {formatCartItemPrice(item) !== "-" ? (
              <span className="flex items-center">
                <DollarIcon className="w-5 h-5 light_grayish_navy pointer-events-none" />{" "}
                {formatCartItemPrice(item)}
              </span>
            ) : (
              "-"
            )}
          </td>
        </tr>
        );
      })}
    </>
  );
};

const RefundTableHeading = () => {
  return REFUND_TABLE_HEADINGS.map((head, index) => (
    <th
      key={index}
      scope="col"
      className="bali_hai px-6 py-3 text-left text-sm font-medium"
    >
      {head}
    </th>
  ));
};
const RefundTableBody = ({ data }) => {
  const TABLE_ROW =
    "px-6 py-4 whitespace-nowrap text-sm font-normal text-black";

  return (
    <>
      {data?.map((invoice, index) => (
        <tr key={index}>
          <td className={TABLE_ROW}>
            {invoice.refundAmount ? (
              <span className="flex items-center">
                <DollarIcon className="w-5 h-5 light_grayish_navy pointer-events-none" />{" "}
                {invoice.refundAmount}
              </span>
            ) : (
              "- - -"
            )}
          </td>
          <td className={TABLE_ROW}>
            {invoice.remainingAmount ? (
              <span className="flex items-center">
                <DollarIcon className="w-5 h-5 light_grayish_navy pointer-events-none" />{" "}
                {invoice.remainingAmount}
              </span>
            ) : (
              "- - -"
            )}
          </td>

          <td className="flex flex-col gap-2 px-6 py-4 whitespace-nowrap text-sm font-normal text-black">
            <span>{invoice.date}</span>
            <span>{invoice.time}</span>
          </td>
        </tr>
      ))}
    </>
  );
};
